import { useReduxState } from 'hooks';
import { localeNames } from 'shared-locales';
import { Alert } from 'components/common';
import { FormGroup } from 'components/common/form';
import { SelectInput } from 'components/common/form/common';

import type { Locales } from 'shared-types';

interface Props {
  isRerun?: boolean;
  language: Locales;
  onLanguageChange: (language: Locales) => void;
}

const EditorCourseEvaluationRunAnalysis = ({
  isRerun,
  language,
  onLanguageChange
}: Props) => {
  const { messages } = useReduxState();

  const languageOptions = Object.entries(localeNames).map(([key, value]) => ({
    label: value,
    value: key
  }));

  return (
    <div>
      <FormGroup
        label={messages.courseEvaluationSelectLanguage}
        style={{ marginBottom: 25 }}
      >
        <SelectInput
          id="course-evaluation-language"
          isSearchable={true}
          onChange={({ value }: { value: Locales }) => onLanguageChange(value)}
          options={languageOptions}
          style={{ maxWidth: 200 }}
          value={languageOptions.find((option) => option.value === language)}
        />
      </FormGroup>

      {isRerun ? (
        <Alert
          style={{ marginBottom: 10 }}
          text={messages.courseEvaluationReRunInfo}
          type="warning-light"
        />
      ) : null}

      <Alert text={messages.courseEvaluationInfo} type="info" />
    </div>
  );
};

export default EditorCourseEvaluationRunAnalysis;
